// Campus photo for /colleges/northern-illinois-university: CC BY-SA 3.0, by Alexbaumgarner, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AAltgeld_Hall_and_Still_Hall_along_College_Ave.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/northern-illinois-university/; credited under the photo.
const photo = {
    "slug": "northern-illinois-university",
    "alt": "Altgeld Hall, a castle-like stone building with turrets, beside brick Still Hall along College Avenue at Northern Illinois University",
    "src": "/colleges/northern-illinois-university/campus-1600.webp",
    "srcSmall": "/colleges/northern-illinois-university/campus-800.webp",
    "srcMid": "/colleges/northern-illinois-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/northern-illinois-university/og.jpg",
    "title": "Altgeld Hall and Still Hall along College Ave",
    "author": "Alexbaumgarner",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AAltgeld_Hall_and_Still_Hall_along_College_Ave.jpg",
    "read": "2026-10-01"
};

export default photo;
